import Vue from 'vue';

export default {
  TOGGLE_ADD_EVENT_DIALOG: (state, payload) => {
    state.addEventDialog = payload;
  },
  TOGGLE_CLOSE_EVENT_DIALOG: (state, payload) => {
    state.closeEventDialog = payload;
  },
  TOGGLE_EVENT_DUTIES_DIALOG: (state, payload) => {
    state.eventDutiesDialog = payload;
  },
  TOGGLE_EVENT_PARTNERS_DIALOG: (state, payload) => {
    state.eventPartnersDialog = payload;
  },
  TOGGLE_EVENT_TRANSLATORS_DIALOG: (state, payload) => {
    state.eventTranslatorsDialog = payload;
  },
  SET_EVENT_PAGE_LAYOUT: (state, payload) => {
    state.eventPageLayout = payload;
  },
  SET_EVENT_PAGE_LAYOUT_SIZE: (state, { position, size }) => {
    state.eventPageLayoutSizes[position] = size;
  },

  SET_EVENT_CURRENT_MANAGER: (state, { eventId, managerId }) => {
    Vue.set(state.eventsCurrentManagers, eventId, managerId);
  },

  // SET_EVENT_MAP_CENTER: (state, { eventId, lat, lng }) => {
  //   state.eventsMapCenters[eventId] = {
  //     lat,
  //     lng
  //   };
  // },

  SET_ARCHIVE_SHOW_FILTERS: (state, payload) => {
    state.archiveView.showFilters = payload;
  },
  SET_SHOW_ALL_EVENTS: (state, payload) => {
    state.showAllEvents = payload;
  },
  SET_EVENT_IDS_TO_SHOW: (state, payload) => {
    state.eventIdsToShow = payload;
  },
  SET_CYCLING_MODE: (state, payload) => {
    state.isCyclingMode = payload;
  },
  SET_CURRENT_EVENT_INDEX: (state, payload) => {
    state.currentEventIndex = payload;
  },
  SET_CYCLING_INTERVAL: (state, payload) => {
    state.cyclingInterval = payload;
  },
  SET_PARTNERS_FOR_ALL_EVENTS: (state, { eventIds }) => {
    state.partnersForAllEvents = eventIds;
  },
  SET_TRANSLATORS_FOR_ALL_EVENTS: (state, { eventIds }) => {
    state.translatorsForAllEvents = eventIds;
  },
};


// WEBPACK FOOTER //
// ./src/store/events/mutations.js